// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey":"#a5a5a5","grey-font-color":"#000000","credit_card":"_38u6Vpv","credit_card_error":"_3pz0Af2","card_bottom":"_1zrxYlN"};